export default () => navigator.userAgent === 'ReactSnap';
